import { render } from "./ArrowRight.vue?vue&type=template&id=2a97f996&scoped=true"
import script from "./ArrowRight.vue?vue&type=script&lang=js"
export * from "./ArrowRight.vue?vue&type=script&lang=js"

import "./ArrowRight.vue?vue&type=style&index=0&id=2a97f996&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a97f996"]])

export default __exports__